import React from 'react';
import PricingCard from '@anonymizePro/components/cards/pricing-card';
import environments from '@app/configs/environments';
import ContactUsCard from '@app/components/cards/contact-us-card';

export const pricing = {
    title: 'Simple Pricing for Secure Documents',
    description: 'Our document anonymizer software empowers you to confidently share sensitive information by providing a straightforward pricing structure.',
    types: [
        {
            title: 'Starter',
            isPopular: false,
            timeLimitation: 'year',
            cost: '100',
            description: 'Perfect for individuals or small businesses needing a basic document anonymization services.',
            pageNumber: 1000,
            buttonText: 'Get Started',
            stripePriceId: environments.STARTER_PLAN_PRICE_ID
        },
        {
            title: 'Standard',
            isPopular: true,
            timeLimitation: 'year',
            cost: '500',
            description: 'Perfect for professionals who handle sensitive data regularly and require robust document anonymization',
            pageNumber: 5000,
            buttonText: 'Get Started',
            stripePriceId: environments.STANDARD_PLAN_PRICE_ID
        },
        {
            title: 'Premium',
            isPopular: false,
            timeLimitation: 'year',
            cost: '1000',
            description: 'Perfect for large businesses or enterprises that need extensive document anonymization for data privacy compliance',
            pageNumber: 10000,
            buttonText: 'Get Started',
            stripePriceId: environments.PREMIUM_PLAN_PRICE_ID
        }
    ]
};

function Pricing() {
    return (
        <div className="mt-[100px] flex flex-col items-center px-10 text-center lg:mt-[273px] lg:px-[128px]">
            <p className="anonymize-h2 text-black-800">{pricing.title}</p>
            <p className="anonymize-p4 mb-16 mt-4 max-w-[365px] text-black-700">{pricing.description}</p>
            <div className="pricingShadow grid grid-flow-row grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                {pricing.types.map((type) => {
                    return <PricingCard key={type.title} pricing={type} />;
                })}
            </div>

            <ContactUsCard />
        </div>
    );
}

export default Pricing;
